<template>
  <b-row>
    <b-col>
      <div class="border" style="background: #fdfeff">
        <div class="d-flex flex-column flex-wrap" style="word-break: break-all">
          <slot></slot>
        </div>
        <hr />
        <div class="d-flex justify-content-end pb-3 px-3">
          <b-button
            variant="outline-primary"
            size="sm"
            @click="$emit('sendTestMessage')"
            :disabled="sendTestMessageButtonDisabled"
          >
            Send Test<font-awesome-icon class="ml-2" icon="paper-plane"/>
          </b-button>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    sendTestMessageButtonDisabled: {
      type: Boolean,
      default: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/campaign-admin/message-previews/emails/wrapper.vue